import React, { useEffect, useRef, useState } from "react";

function AutoComplete({
  outerDivClass,
  value,
  inputClassName,
  placeholder,
  optionClass,
  options,
  onChange,
  required,
  onInputChange,
  ...props
}) {
  const [selectedValue, setselectedValue] = useState(value || null);
  const [ShowOption, setShowOption] = useState(false);
  const [listFocus, setListFocus] = useState(false);
  const [list, setList] = useState([]);
  const inputref = useRef();
  useEffect(() => {
    setList(options);
  }, [options]);
  const HandleSearch = (value) => {
    onInputChange(value);
    if (!value) {
      setList(options);
      return true;
    }
    var filtered = list.filter((items) => items.includes(value));
    setList(filtered);
  };

  const HandleOnChange = (mobile) => {
    setselectedValue(mobile);
    setShowOption(false);
    setList(options);
    inputref.current.value = mobile;
    setListFocus(false);
    onChange(mobile);
  };

  return (
    <div
      className={`${outerDivClass} position-relative p-0`}
      onBlur={() => {
        if (!listFocus) setShowOption(false);
      }}
    >
      <input autoComplete="off"
        defaultValue={selectedValue}
        ref={inputref}
        className={inputClassName}
        placeholder={placeholder}
        onFocus={() => setShowOption(true)}
        onChange={(e) => HandleSearch(e.target.value)}
        required={required}
        {...props}
      />
      {ShowOption && (
        <div
          className={`${optionClass} position-absolute bg-light border border-secondary`}
          style={{ maxHeight: "20vh", overflowY: "scroll" }}
          onMouseEnter={() => {
            setListFocus(true);
          }}
          onMouseLeave={() => {
            setListFocus(false);
          }}
        >
          {list &&
            list.map((items) => (
              <p
                className="text-dark px-2 py-1 my-0"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  HandleOnChange(items);
                }}
              >
                {items}
              </p>
            ))}
        </div>
      )}
    </div>
  );
}

export default AutoComplete;
